module.exports = __webpack_public_path__ + "public/images/about-1.945b2a7351d4363971badbf4fb96dd61.png";